export function LogoMark({ size = 34, tile = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      aria-hidden="true"
      className="shrink-0"
    >
      <defs>
        <linearGradient id="bliGrad" x1="25" y1="10" x2="80" y2="92" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor={tile ? "#EAF4F8" : "#14304F"} />
          <stop offset="0.6" stopColor={tile ? "#5ECFBE" : "#1E6E8C"} />
          <stop offset="1" stopColor="#2BBFAB" />
        </linearGradient>
      </defs>
      {tile && <rect width="100" height="100" rx="22" fill="#101F38" />}
      <g fill="none" stroke="url(#bliGrad)" strokeWidth="15" strokeLinecap="round">
        <path d="M31 15 H54 A18.75 18.75 0 0 1 54 52.5 H31" />
        <path d="M31 52.5 H62 A18.75 18.75 0 0 1 62 90 H31" />
      </g>
      <rect x="7" y="28" width="15" height="13" rx="5" fill="#2BBFAB" />
      <rect x="7" y="49" width="15" height="41" rx="7.5" fill="url(#bliGrad)" />
    </svg>
  );
}

export default function Logo({ dark = false, compact = false }) {
  return (
    <span className="inline-flex items-center gap-2.5 select-none">
      <LogoMark size={compact ? 30 : 36} />
      {!compact && (
        <span className="leading-none">
          <span
            className={`block font-display font-extrabold tracking-tight text-[16px] ${
              dark ? "text-white" : "text-navy"
            }`}
          >
            BOTTOMLINE
          </span>
          <span
            className="block text-[8.5px] font-bold uppercase tracking-[0.42em] mt-1 text-teal"
          >
            IMPROVEMENTS
          </span>
        </span>
      )}
    </span>
  );
}
